import * as React from 'react';
import MessageBubble from 'components/MessageBubble/MessageBubble';
import styles from './TypingIndicator.css';
const TypingIndicator = () => {
    return (<MessageBubble className={styles['typing-indicator-message-bubble']} showBubblePointer>
			<div className={styles['typing-indicator']}>
				<div className={styles['dot']}/>
				<div className={styles['dot']}/>
				<div className={styles['dot']}/>
			</div>
		</MessageBubble>);
};
export default TypingIndicator;
